"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fragmentPeptide = fragmentPeptide;
const peptide_1 = require("peptide");
function fragmentPeptide(sequence, options = {}) {
    const { digestion = {}, protonation, fragmentation, protonationPH } = options;
    sequence = (0, peptide_1.sequenceToMF)(sequence);
    let fragmentsArray = [sequence];
    // do we also have some digest fragments ?
    if (digestion.enzyme) {
        let digests = (0, peptide_1.digestPeptide)(sequence, digestion);
        if (protonation) {
            digests = (0, peptide_1.chargePeptide)(digests, {
                pH: protonationPH,
            });
        }
        fragmentsArray = fragmentsArray.concat(digests);
    }
    // allow neutral loss
    if (options.allowNeutralLoss) {
        sequence = (0, peptide_1.allowNeutralLoss)(sequence);
    }
    // apply protonation
    if (protonation) {
        sequence = (0, peptide_1.chargePeptide)(sequence, { pH: protonationPH });
    }
    // calculate fragmentation
    let fragments = (0, peptide_1.generatePeptideFragments)(sequence, fragmentation);
    fragmentsArray = fragmentsArray.concat(fragments);
    return fragmentsArray;
}
//# sourceMappingURL=fragmentPeptide.js.map